<!-- begin #footer -->
<div id="footer" class="footer">
    &copy; 2019-{{year}} Iglesia Adventista del Séptimo día - Unión Chilena
</div>
<!-- end #footer -->
